export class CardsSlider {
  element: HTMLElement;
  sliderContainer: HTMLElement;
  pointsContainer: HTMLElement;
  isMobileView: boolean;
  currentPosition: number = 0;

  constructor(element: HTMLElement) {
    this.element = <HTMLElement>element;
    this.sliderContainer = <HTMLElement>element.querySelectorAll('[slider-container]')[0];
    this.pointsContainer = <HTMLElement>element.querySelectorAll('[slider-points]')[0];
    this.detectMediaQuery();

    let actions = <Array<Element>>Array.prototype.slice.call(element.querySelectorAll('[slider-action]'));

    for (let action of actions) {
      action.addEventListener("click", action.getAttribute("slider-action") == 'right' ? this.slideToDirection.bind(this, 1) : this.slideToDirection.bind(this, -1));
    }
  }

  slide(position: number): void {
    if (this.isMobileView) {
      let el = <HTMLElement>this.sliderContainer.children[position];
      let left = el.offsetLeft;
      this.sliderContainer.style.setProperty("left", -left + "px");
    } else {
      if (position == 0) {
        this.sliderContainer.style.setProperty("left", "0");
      } else {
        let scrollWidth = this.sliderContainer.scrollWidth,
          containerWidth = this.sliderContainer.clientWidth;

        this.sliderContainer.style.setProperty("left", containerWidth - scrollWidth + "px");
      }
    }

    let points = <Array<HTMLElement>>Array.prototype.slice.call(this.pointsContainer.children);

    for (let p of points) {
      p.classList.remove("selected");
    }

    let point = points[position];
    point.classList.add("selected");

    this.element.classList.remove("right-state");
    this.element.classList.remove("left-state");

    if (position == 0) {
      this.element.classList.add("left-state");
    }

    if (position == points.length - 1) {
      this.element.classList.add("right-state");
    }

    this.currentPosition = position;
  }

  slideToDirection(direction: number): void {
    var newPosition = this.currentPosition + direction;

    if (newPosition >= 0 && newPosition < this.pointsContainer.childElementCount) {
      this.slide(newPosition);
    }
  }

  buildPoints(): void {
    var points = this.pointsContainer;

    while (points.hasChildNodes()) {
      points.removeChild(points.lastChild);
    }

    var length = this.sliderContainer.childElementCount;

    if (!this.isMobileView) {
      length = length / 2;
    }

    for (let i = 0; i < length; i++) {
      var point = document.createElement("div");
      point.classList.add("point");
      point.addEventListener("click", this.slide.bind(this, i));

      if (i == 0) {
        point.classList.add("selected");
      }

      points.appendChild(point);
    }
  }

  detectMediaQuery(): void {
    let mq = window.matchMedia('(max-width: 1020px)');

    if (mq) {
      mq.addListener(this.onMediaQueryChange.bind(this));
      this.onMediaQueryChange(mq);
    }
  }

  onMediaQueryChange(mq: MediaQueryList): void {
    this.isMobileView = mq.matches;
    this.buildPoints();
    this.slide(0);
  }
}


// WEBPACK FOOTER //
// ./static-content/public/javascripts/cards-slider.ts